export default __webpack_public_path__ + "media/images/symbols/sharp-chevron-02e2b88f2df583ed659b96dc15a541df.svg";